import { Modal, ModalProps, Typography } from 'antd';
import { useCreate } from '@refinedev/core';

export interface CloseThreadModalProps {
  modalClose: () => void;
  modalProps: ModalProps;
  refetch: () => void;
  forumId: string | undefined;
}

export const CloseThreadModal = ({
  modalProps,
  forumId,
  modalClose,
  refetch
}: CloseThreadModalProps) => {
  const { mutateAsync: closeTopic } = useCreate();

  const handleCreate = async () => {
    const resource = `faq_coordinators/${forumId}/close`;

    try {
      await closeTopic({
        resource,
        values: {},
        successNotification: () => ({
          type: 'success',
          description: 'Tudo certo!',
          message: 'Tópico finalizado com sucesso'
        }),
        errorNotification: () => ({
          description: 'Algo deu errado',
          message:
            'Não foi possível finalizar o tópico. É necessário responder antes de marcar como concluído.',
          type: 'error'
        })
      });

      refetch();
      modalClose();
    } catch {
      // Refine already displays errorNotification
    }
  };

  return (
    <Modal
      style={{ maxWidth: 600 }}
      {...modalProps}
      title="Deseja marcar como concluído"
      cancelText="Voltar"
      okText="Marcar como concluído"
      onOk={handleCreate}
      className="!w-[1022px]"
      destroyOnClose
    >
      <Typography.Paragraph>
        Essa ação não pode ser revertida
      </Typography.Paragraph>
    </Modal>
  );
};
